export default class SignalingManager {
  constructor(socket) {
    this.socket = socket;
  }
  join(roomId, name) {
    this.socket.emit('join-room', { roomId, name });
  }
  sendSignal(to, from, data) {
    this.socket.emit('signal', { to, from, data });
  }
  requestUserList(roomId) {
    this.socket.emit('get-user-list', { roomId });
  }
  leave(roomId) {
    this.socket.emit('leave-room', { roomId });
  }
}
